<template>
    <div class="wrapper">
        <Header />
        <!-- <side-bar v-if="$store.state.authentication.user_role == 'super-admin'"> -->
        <side-bar>
            <sidebar-link to="/dashboard">
                <md-icon>dashboard</md-icon>
                <p>{{translate(locale.dashboard)}}</p>
            </sidebar-link>
            <div
                style="margin: 10px 0 10px 15px; height: 1px; width: calc(100% - 30px);background-color: rgba(180, 180, 180, 0.3);">
            </div>
            <sidebar-link to="/users">
                <md-icon>groups</md-icon>
                <p>{{translate(locale.user)}}</p>
            </sidebar-link>
            <sidebar-link to="/system_clients">
                <md-icon>memory</md-icon>
                <p>{{translate(locale.systemClients)}}</p>
            </sidebar-link>
            <sidebar-link to="/administrators">
                <md-icon>supervised_user_circle</md-icon>
                <p>{{translate(locale.administrators)}}</p>
            </sidebar-link>
            <sidebar-link to="/settings">
                <md-icon>settings</md-icon>
                <p>{{translate(locale.settings)}}</p>
            </sidebar-link>
        </side-bar>

        <div class="main-panel" style="padding-top:80px">

            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>

            <Footer />
        </div>
    </div>
</template>

<script>
    import Footer from '../components/Footer.vue'
    import Header from '../components/Header.vue'

    export default {
        components: { Header, Footer }
    }
</script>

<style>
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .1s
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0
    }
</style>


// WEBPACK FOOTER //
// src/pages/Layout.vue